import { render } from "./MailingBlockButtonEditor.vue?vue&type=template&id=5511ea9e"
import script from "./MailingBlockButtonEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockButtonEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__